<div [hidden]="!loading" [ngClass]="{ loading: loading }">
  <mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
</div>
